import React from 'react';
import { useHibana } from 'src/context/HibanaContext';

type OGOnlyWrapperProps = {
  as: $TODOFIXME;
  children: React.ReactNode;
};

export default function OGOnlyWrapper(props: OGOnlyWrapperProps) {
  const [state] = useHibana();
  const { isHibanaEnabled } = state;
  const { as, ...rest } = props;
  const Component = as;

  return !isHibanaEnabled ? <Component {...rest} /> : <>{props.children}</>;
}
